export enum RiskCategoryType {
  nhg = 'NHG',
  smallerThanOrEqualTo65Percent = '≤65%',
  smallerThanOrEqualTo85Percent = '>65%-≤85%',
  smallerThanOrEqualTo90Percent = '>85%-≤90%',
  largerThan90Percent = '>90%'
}

export enum RiskCategoryTypeLegacy {
  largerThan85Percent = '>85%'
}
